// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveList: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="currentColor" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 45 43" enableBackground="new 0 0 45 43" xmlSpace="preserve">
<polygon points="13.27,1.25 11.56,0.09 5.12,9.59 1.96,6.42 0.5,7.88 5.43,12.81 "/>
<polygon points="5.12,39.69 1.96,36.52 0.5,37.98 5.43,42.91 13.27,31.35 11.56,30.19 "/>
<polygon points="13.27,16.3 11.56,15.14 5.12,24.64 1.96,21.47 0.5,22.93 5.43,27.86 "/>
<rect x="15.87" y="36.19" width="28.63" height="1.97"/>
<rect x="15.87" y="6.09" width="28.63" height="1.97"/>
<rect x="15.87" y="21.14" width="28.63" height="1.97"/>
</svg>;
};

export default React.memo(SaveList);
